import { Detection } from '@intelligent-play-v2/domain';
import { queryBuilder } from '~/api';

export const getLive = async (pitchId: string): Promise<Detection[]> => {
  const { data } = await queryBuilder('GET', `pitches/${pitchId}/live`);
  return data;
};
